<template>
  <div class="data">
    <span class="title">{{ $tc('dashboard.topCommunities', topCommunities.length) }}</span>
    <div class="name" v-for="(value, index) in topCommunities"
         :key="index"
         :style="opacity(index)"
         v-tooltip="tooltip(value)"
    >
      ({{ total(value) }}) {{ value.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopCommunities',
  directives: {},
  props: {
    topCommunities: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    opacity(index) {
      let opacity = 1 - (index - 1) * 0.1
      return 'color: rgba(0, 125, 143, ' + opacity + ' );'
    },
    total(value) {
      return value.postsCount + value.commentsCount + value.likesCount
    },
    tooltip(value) {
      return `Posts: ${value.postsCount}<br/>Comments: ${value.commentsCount}<br/>Likes: ${value.likesCount}`
    }
  }
}
</script>

<style scoped lang="scss">
.data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.title {
  text-transform: capitalize;
  font-weight: 700;
  font-size: 18px;
}

.name {
  text-transform: uppercase;
  color: rgba(0, 125, 143, 0.9);
  font-weight: 600;
  margin-top: 18px;
}
</style>
